var map = {
	"./advance-market.svg": "3a89",
	"./dashboard.svg": "86c0",
	"./history.svg": "50b0",
	"./invite.svg": "97c3",
	"./main-market.svg": "fc46",
	"./markets.svg": "9595",
	"./setting.svg": "9922",
	"./wallets.svg": "0ce7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afe0";